import React from 'react';
import Homepage from './pages/homepage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        {/* Define more routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;
